import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChatBarWindow = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 80 80",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M63,39.8999819 L63,46 L66,46 L66,48 L14,48 L14,46 L17,46 L17,38 C17,35.790861 18.790861,34 21,34 L57.1000181,34 C57.0344303,34.3231099 57,34.6575342 57,35 C57,37.7614237 59.2385763,40 62,40 C62.3424658,40 62.6768901,39.9655697 63,39.8999819 Z M62,38 C60.3431458,38 59,36.6568542 59,35 C59,33.3431458 60.3431458,32 62,32 C63.6568542,32 65,33.3431458 65,35 C65,36.6568542 63.6568542,38 62,38 Z" })
});
export default SvgChatBarWindow;
